import { createSlice } from '@reduxjs/toolkit'
import React from 'react'    

     
let initialState={ 
 product:{},
}
if(window.localStorage.ProductStorage){
  const product_storage=JSON.parse(window.localStorage.ProductStorage);
  initialState={
    product:product_storage.product,
  }
}

export const ProductSlice =  createSlice({
  name: 'Auth',
  initialState,
  reducers: {
    change_product: (state,action) => {
        state.product=action.payload;
        window.localStorage.setItem("ProductStorage",JSON.stringify({
            'product':state.product,
          }));
      
    },
   
  },
})
export const {change_product}=ProductSlice.actions
export default ProductSlice.reducer